import React, { useEffect, useState } from "react";
import {
  Table,
  Empty,
  Popconfirm,
  notification,
  Button,
  Drawer,
  Tooltip,
  Col,
  Modal,
  Row,
  Tabs,
} from "antd";
import {
  EditOutlined,
  DeleteOutlined,
  BarsOutlined,
  PlusOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import MonthlyPlanAdd from "../Forms/MonthlyPlanAdd";
import MonthlyPlanUpdate from "../Forms/MonthlyPlanUpdate";
import { odata } from "../Filters/Helper";
import RequestHandler from "../../util/RequestHandler";
import MonthlyPlanListTableFilter from "../Filters/MonthlyPlanListTableFilter";
import CheckPromissoryTableFilter from "../Filters/CheckPromissoryTableFilter";
import { RowHelper } from "../../util/TableHelper";

const { TabPane } = Tabs;
const { confirm } = Modal;

const openNotificationWithIconDelete = (type) => {
  notification[type]({
    message: "BAŞARILI",
    description: "Silme işlemi başarı ile gerçekleşti.",
    duration: 2,
  });
};
const openNotificationWithIconWarningDelete = (type) => {
  notification[type]({
    message: "HATA",
    description: "Silme işlemi sırasında bir hata oluştu.",
    duration: 2,
  });
};

const MonthlyPlanList = () => {
  const [tableData, setTableData] = useState({
    data: [],
    total: 0,
    loading: true,
  });
  const [checkTableData, setCheckTableData] = useState({
    data: [],
    total: 0,
    loading: true,
  });
  const [tableDataQueryOptions, setTableDataQueryOptions] = useState({
    skip: 0,
    take: 15,
    current: 1,
    filter: "",
  });
  const [tableCheckDataQueryOptions, setTableCheckDataQueryOptions] = useState({
    skip: 0,
    take: 15,
    current: 1,
    filter: "",
  });

  const [order, setOrder] = useState("&$orderby=addDate desc");
  const [teminatDropdown, setTeminatDropdown] = useState([]);
  const [ManualTransactionTypeDropdown, setManualTransactionTypeDropdown] =
    useState([]);
  const [currencyDropdown, setCurrencyDropdown] = useState([]);
  const [monthlyPlanId, setMonthlyPlanId] = useState("");
  const [FirmIdUpdate, setFirmIdUpdate] = useState("");
  const [MonthlyPlanTypeId, setMonthlyPlanTypeId] = useState("");
  const [
    OtherTransactionProcessTypeUpdate,
    setOtherTransactionProcessTypeUpdate,
  ] = useState("");
  const [CurrencyCode, setCurrencyCode] = useState("");
  const [Amount, setAmount] = useState("");
  const [TransactionDate, setTransactionDate] = useState("");
  const [DescriptionUpdate, setDescriptionUpdate] = useState("");

  const [paymentPlace, setPaymentPlace] = useState("");
  const [serialNo, setSerialNo] = useState("");
  const [bankId, setbankId] = useState("");
  const [bankDropdown, setbankDropdown] = useState([]);
  const [bankBranchCode, setBankBranchCode] = useState("");
  const [vkn, setVkn] = useState("");
  const [salesmanCode, setSalesmanCode] = useState("");

  const [visible, setVisible] = useState(false);
  const [checkVisibility, setCheckVisibility] = useState(false);
  const [isRepeat, setIsRepeat] = useState(false);
  const [changeAll, setChangeAll] = useState(false);
  const [visibleUpdate, setvisibleUpdate] = useState(false);
  const [checkVisibilityUpdate, setcheckVisibleUpdate] = useState(false);
  const [tabPanelKey, setTabPanelKey] = useState("1");
  const [checkPlan, setCheckPlan] = useState(false);

  useEffect(() => getTableData(), [order, tableDataQueryOptions]);
  useEffect(() => getCheckTableData(), [order, tableCheckDataQueryOptions]);

  useEffect(() => {
    RequestHandler.get(`/Types/GetManualTransactionTypes`).then((response) => {
      setTeminatDropdown(response);
    });

    RequestHandler.get(`/Currency`).then((response) => {
      setCurrencyDropdown(response.value);
    });

    RequestHandler.get(`/MonthlyPlanType`).then((response) => {
      setManualTransactionTypeDropdown(response.value);
    });
  }, []);

  const getFilterQuery = () => {
    const { filter } = tableDataQueryOptions;

    const conditions = [];
    let query = "";

    if (filter) {
      conditions.push(filter);
    }

    if (conditions.length !== 0) {
      query = "$filter=" + conditions.join(" and ");
    }
    return query;
  };

  const getCheckFilterQuery = () => {
    const { filter } = tableCheckDataQueryOptions;

    const conditions = [];
    let query = "";

    if (filter) {
      conditions.push(filter);
    }

    if (conditions.length !== 0) {
      query = "$filter=" + conditions.join(" and ");
    }
    return query;
  };

  const onCheckPromissoryAddSuccess = () => {
    getCheckTableData();
    setTabPanelKey("2");
    setCheckVisibility(false);
  };

  const getTableData = () => {
    setTableData({
      ...tableData,
      loading: true,
    });
    const { skip, take } = tableDataQueryOptions;

    RequestHandler.get(
      `/MonthlyPlan?$count=true&${getFilterQuery()}${order}&$skip=${skip}&$top=${take}`
    ).then((response) => {
      if (Array.isArray(response.value)) {
        setTableData({
          data: response.value,
          total: response["@odata.count"],
          loading: false,
        });
      }
    });
  };

  const getCheckTableData = () => {
    setCheckTableData({
      ...checkTableData,
      loading: true,
    });
    const { skip, take } = tableCheckDataQueryOptions;

    RequestHandler.get(
      `/CheckPromissory?$count=true&${getCheckFilterQuery()}${order}&$skip=${skip}&$top=${take}`
    ).then((response) => {
      if (Array.isArray(response.value)) {
        setCheckTableData({
          data: response.value,
          total: response["@odata.count"],
          loading: false,
        });
      }
    });
  };

  const paging = (p, filters, sorter) => {
    let order = "";
    if (sorter.columnKey && sorter.order) {
      order =
        "&" +
        (sorter.order === "ascend"
          ? odata.orderBy(sorter.columnKey)
          : odata.orderByDesc(sorter.columnKey));
    }
    setOrder(order);
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: (p.current - 1) * prevState.take,
        take: p.pageSize,
        current: p.current,
      };
    });

    setTableCheckDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: (p.current - 1) * prevState.take,
        take: p.pageSize,
        current: p.current,
      };
    });
  };

  const onClearTableFilter = () => {
    setTableDataQueryOptions({
      skip: 0,
      current: 1,
      take: tableDataQueryOptions.take,
      filter: "",
    });
  };

  const onClearCheckTableFilter = () => {
    setTableCheckDataQueryOptions({
      skip: 0,
      current: 1,
      take: tableCheckDataQueryOptions.take,
      filter: "",
    });
  };

  const onFinishTableFilter = (query) => {
    setTableDataQueryOptions((prevState) => {
      return { skip: 0, current: 1, take: prevState.take, filter: query };
    });
  };

  const onFinishCheckTableFilter = (query) => {
    setTableCheckDataQueryOptions((prevState) => {
      return { skip: 0, current: 1, take: prevState.take, filter: query };
    });
  };

  const showDrawerUpdate = (value) => {
    RequestHandler.get(`/MonthlyPlan/GetById/${value}`).then((response) => {
      setMonthlyPlanTypeId(response.monthlyPlanTypeId);
      setCurrencyCode(response.currencyId.toString());
      setAmount(response.amount);
      setOtherTransactionProcessTypeUpdate(
        response.otherTransactionProcessType.toString()
      );
      setTransactionDate(response.transactionDate);
      setDescriptionUpdate(response.description);
      setMonthlyPlanId(value);
      setFirmIdUpdate(response.firmId);
      if (response.isRepeat) {
        confirm({
          title:
            "Yapacağınız güncellemenin tüm tekrarlı kayıtlara uygulanmasını ister misiniz?",
          icon: <ExclamationCircleOutlined />,
          content: "",
          cancelText: "Hayır",
          okText: "Evet",
          onOk() {
            setChangeAll(true);
            setvisibleUpdate(true);
          },
          onCancel() {
            setChangeAll(false);
            setvisibleUpdate(true);
          },
        });
      } else {
        setChangeAll(false);
        setvisibleUpdate(true);
      }
    });
  };

  const tabChangeFunction = (index) => {
    switch (index) {
      case "1":
        getTableData();
        break;
      case "2":
        getCheckTableData();
        break;
      default:
        getTableData();
        break;
    }
  };

  const showCheckDrawerUpdate = (value) => {
    var isCheckPromissory = checkTableData.data.find(
      (item) => item.id === value
    );
    if (
      isCheckPromissory &&
      (isCheckPromissory.monthlyPlanTypeName.toLowerCase().trim() === "çek" ||
        isCheckPromissory.monthlyPlanTypeName.toLowerCase().trim() === "senet")
    ) {
      RequestHandler.get(`/CheckPromissory/GetById/${value}`).then(
        (response) => {
          setMonthlyPlanTypeId(response.monthlyPlanTypeId);
          setCurrencyCode(response.currencyId.toString());
          setAmount(response.amount);
          setOtherTransactionProcessTypeUpdate(
            response.otherTransactionProcessType.toString()
          );
          setCheckPlan(
            response.monthlyPlanTypeName.toLowerCase().trim() === "senet"
          );
          setTransactionDate(response.transactionDate);
          setDescriptionUpdate(response.description);
          setMonthlyPlanId(value);
          setFirmIdUpdate(response.firmId);
          setVkn(response.vkn);
          setbankId(response.bankId);
          setBankBranchCode(response.bankBranchCode);
          setPaymentPlace(response.paymentPlace);
          setSerialNo(response.serialNo);
          setTeminatDropdown(response.teminatDropdown);
          setSalesmanCode(response.salesmanCode);
          setcheckVisibleUpdate(true);
          setTabPanelKey("2");
        }
      );
    }
  };
  const onClose = () => {
    setVisible(false);
  };
  const onCloseUpdate = () => {
    setvisibleUpdate(false);
  };
  const onCloseCheckUpdate = () => {
    setcheckVisibleUpdate(false);
  };

  const handleDelete = (key, changeAllValue) => {
    RequestHandler.delete(
      `/MonthlyPlan?id=${key}&isChangeAll=${changeAllValue}`,
      undefined,
      false,
      { rawResponse: true }
    ).then((res) => {
      if (res.status === 204 || res.status === 200) {
        openNotificationWithIconDelete("success");
        getTableData();
        getCheckTableData();
      } else {
        openNotificationWithIconWarningDelete("error");
      }
    });
  };

  const getData = (val) => {
    if (val === "success") {
      getTableData();
      getCheckTableData();
      setvisibleUpdate(false);
      setVisible(false);
    }
  };

  const getCheckData = (val) => {
    if (val === "success") {
      getTableData();
      getCheckTableData();
      setcheckVisibleUpdate(false);
      setCheckVisibility(false);
    }
  };

  const columns = [
    {
      title: "Proje",
      dataIndex: "firmName",
      key: "firmName",
      render: (text, row, index) =>
        text === null ? (
          ""
        ) : (
          <Tooltip placement="topLeft" title={text}>
            {text.substring(0, 15).length < 15
              ? text.substring(0, 15) + ""
              : text.substring(0, 15) + "..."}
          </Tooltip>
        ),
    },
    {
      title: "İşlem Tipi",
      dataIndex: "monthlyPlanTypeName",
      key: "monthlyPlanTypeName",
    },
    {
      title: "İşlem Türü",
      dataIndex: "otherTransactionProcessType",
      key: "otherTransactionProcessType",
    },
    {
      title: "Proje Kodu",
      dataIndex: "firmCode",
      key: "firmCode",
    },
    {
      title: "Tarih",
      dataIndex: "transactionDate",
      key: "transactionDateValue",
      sorter: true,
      render: (text, row, index) => {
        {
          return <div>{text.substring(0, 10)}</div>;
        }
      },
    },
    {
      title: "Tutar",
      dataIndex: "amountString",
      key: "amount",
      align: "left",
      sorter: true,
      render: (text, row, index) => {
        {
          return <div style={{ width: "170%" }}>{text}</div>;
        }
      },
    },
    {
      title: "Döviz",
      dataIndex: "currencyCode",
      key: "currencyCode",
    },
    {
      title: "Açıklama",
      align: "left",
      dataIndex: "description",
      key: "description",
      render: (text) =>
        text === null ? (
          ""
        ) : (
          <Tooltip placement="topLeft" title={text}>
            {text?.substring(0, 50) === undefined
              ? " "
              : text?.substring(0, 50).trim().length < 50
              ? text + ""
              : text?.substring(0, 50) + "..."}
          </Tooltip>
        ),
    },
    {
      title: "Düzenle",
      dataIndex: "operation",
      align: "right",
      width: "10%",
      render: (text, record) => (
        <a
          onClick={() => {
            showDrawerUpdate(record.id);
          }}
          style={{ color: "orange", fontSize: "130%" }}
        >
          <EditOutlined />
        </a>
      ),
    },
    {
      title: "Sil",
      dataIndex: "operation",
      width: "1%",
      render: (text, record) => (
        <Popconfirm
          title="Silmek istiyor musunuz?"
          okText="Evet"
          cancelText="Hayır"
          onConfirm={() => {
            record.isRepeat
              ? confirm({
                  title:
                    "Yapacağınız silme işleminin tüm tekrarlı kayıtlara uygulanmasını ister misiniz?",
                  icon: <ExclamationCircleOutlined />,
                  content: "",
                  cancelText: "Hayır",
                  okText: "Evet",
                  onOk() {
                    handleDelete(record.id, true);
                  },
                  onCancel() {
                    handleDelete(record.id, false);
                  },
                })
              : handleDelete(record.id, false);
          }}
        >
          <a style={{ color: "red", fontSize: "130%" }}>
            <DeleteOutlined />
          </a>
        </Popconfirm>
      ),
    },
  ];

  const CheckPromissoryColumns = [
    {
      title: "Proje",
      dataIndex: "firmName",
      key: "firmName",
      render: (text, row, index) =>
        text === null ? (
          ""
        ) : (
          <Tooltip placement="topLeft" title={text}>
            {text.substring(0, 15).length < 15
              ? text.substring(0, 15) + ""
              : text.substring(0, 15) + "..."}
          </Tooltip>
        ),
    },
    {
      title: "İşlem Tipi",
      dataIndex: "monthlyPlanTypeName",
      key: "monthlyPlanTypeName",
    },
    {
      title: "İşlem Türü",
      dataIndex: "otherTransactionProcessType",
      key: "otherTransactionProcessType",
    },
    {
      title: "Ödeme Yeri",
      dataIndex: "paymentPlace",
      key: "paymentPlace",
      isRowDetail: true,
    },
    {
      title: "Tarih",
      dataIndex: "transactionDate",
      key: "transactionDateValue",
      sorter: true,
      render: (text, row, index) => {
        {
          return <div>{text.substring(0, 10)}</div>;
        }
      },
    },
    {
      title: "Tutar",
      dataIndex: "amountString",
      key: "amount",
      align: "left",
      sorter: true,
      render: (text, row, index) => {
        {
          return <div style={{ width: "170%" }}>{text}</div>;
        }
      },
    },
    {
      title: "Döviz",
      dataIndex: "currencyCode",
      key: "currencyCode",
    },
    {
      title: "Seri No",
      dataIndex: "serialNo",
      key: "serialNo",
    },
    {
      title: "Satış Elemanı",
      dataIndex: "salesmanCode",
      key: "salesmanCode",
      isRowDetail: true,
    },
    {
      title: "Banka Adı",
      dataIndex: "bankName",
      key: "bankName",
      isRowDetail: true,
    },
    {
      title: "Banka Şube Kodu",
      dataIndex: "bankBranchCode",
      key: "bankBranchCode",
      isRowDetail: true,
    },
    {
      title: "Düzenle",
      dataIndex: "operation",
      align: "right",
      width: "10%",
      render: (text, record) => (
        <a
          onClick={() => {
            showCheckDrawerUpdate(record.id);
          }}
          style={{ color: "orange", fontSize: "130%" }}
        >
          <EditOutlined />
        </a>
      ),
    },
    {
      title: "Sil",
      dataIndex: "operation",
      width: "1%",
      render: (text, record) => (
        <Popconfirm
          title="Silmek istiyor musunuz?"
          okText="Evet"
          cancelText="Hayır"
          onConfirm={() => {
            record.isRepeat
              ? confirm({
                  title:
                    "Yapacağınız silme işleminin tüm tekrarlı kayıtlara uygulanmasını ister misiniz?",
                  icon: <ExclamationCircleOutlined />,
                  content: "",
                  cancelText: "Hayır",
                  okText: "Evet",
                  onOk() {
                    handleDelete(record.id, true);
                  },
                  onCancel() {
                    handleDelete(record.id, false);
                  },
                })
              : handleDelete(record.id, false);
          }}
        >
          <a style={{ color: "red", fontSize: "130%" }}>
            <DeleteOutlined />
          </a>
        </Popconfirm>
      ),
    },
  ];
  const detailColumns = [
    {
      title: "Açıklama",
      dataIndex: "description",
    },
  ];

  return (
    <>
      <Row>
        <Col xs={16}>
          <p style={{ fontSize: "120%", marginTop: -5 }}>
            <BarsOutlined /> GELİR-GİDER PLANLAMA
          </p>
        </Col>
        <Col xs={8}>
          <Row justify="end" align="middle" style={{ paddingRight: 16 }}>
            <Button
              type="primary"
              onClick={() => {
                setCheckVisibility(true);
              }}
            >
              <PlusOutlined /> Çek Senet Ekle
            </Button>
            <Button
              type="primary"
              onClick={() => {
                setVisible(true);
              }}
            >
              <PlusOutlined /> Aylık Plan Ekle
            </Button>
          </Row>
        </Col>
      </Row>
      {tabPanelKey === "1" ? (
        <MonthlyPlanListTableFilter
          onClearFilter={onClearTableFilter}
          onFinishFilter={onFinishTableFilter}
          style={{ marginTop: 12, marginBottom: 12 }}
        />
      ) : (
        <CheckPromissoryTableFilter
          onClearFilter={onClearCheckTableFilter}
          onFinishFilter={onFinishCheckTableFilter}
          style={{ marginTop: 12, marginBottom: 12 }}
        />
      )}

      <Tabs
        defaultActiveKey="1"
        onChange={(index) => setTabPanelKey(index)}
        onTabClick={tabChangeFunction}
      >
        <TabPane tab="Aylık Planlar" key="1">
          <Row id="tableArea">
            <Col span={24}>
              <Table
                columns={columns}
                expandable={{
                  expandedRowRender: (row) =>
                    RowHelper.renderRowDetail({
                      data: row,
                      columns: detailColumns,
                    }),
                }}
                locale={{
                  emptyText: (
                    <Empty
                      image={Empty.PRESENTED_IMAGE_SIMPLE}
                      description="Veri Yok"
                    />
                  ),
                }}
                style={{ overflowX: "auto", maxHeight: "100%", width: "100%" }}
                rowKey="id"
                filterable={true}
                sortable={true}
                pageable={true}
                onChange={paging}
                pagination={{
                  defaultPageSize: tableDataQueryOptions.take,
                  pageSizeOptions: ["15", "25", "50", "100"],
                  total: tableData.total,
                  current: tableDataQueryOptions.current,
                }}
                dataSource={tableData.data}
                loading={tableData.loading}
                size="small"
              />
            </Col>
          </Row>
        </TabPane>
        <TabPane tab="Çek-Senet" key="2">
          <Row id="tableArea">
            <Col span={24}>
              <Table
                columns={CheckPromissoryColumns.filter(
                  (column) => !column.isRowDetail
                )}
                expandable={{
                  expandedRowRender: (row) =>
                    RowHelper.renderRowDetail({
                      data: row,
                      columns: CheckPromissoryColumns.filter(
                        (column) => column.isRowDetail
                      ),
                    }),
                }}
                locale={{
                  emptyText: (
                    <Empty
                      image={Empty.PRESENTED_IMAGE_SIMPLE}
                      description="Veri Yok"
                    />
                  ),
                }}
                style={{ overflowX: "auto", maxHeight: "100%", width: "100%" }}
                rowKey="id"
                filterable={true}
                sortable={true}
                pageable={true}
                onChange={paging}
                pagination={{
                  defaultPageSize: tableCheckDataQueryOptions.take,
                  pageSizeOptions: ["15", "25", "50", "100"],
                  total: checkTableData.total,
                  current: tableCheckDataQueryOptions.current,
                }}
                dataSource={checkTableData.data}
                loading={checkTableData.loading}
                size="small"
              />
            </Col>
          </Row>
        </TabPane>
      </Tabs>


      <Drawer
        title="Aylık Plan Ekle"
        onClose={onClose}
        visible={visible}
        bodyStyle={{ padding: 24 }}
        width={500}
        footer={<div style={{ textAlign: "right" }}></div>}
      >
        <MonthlyPlanAdd />
      </Drawer>

      <Drawer
        title="Aylık Plan Güncelle"
        onClose={onCloseUpdate}
        visible={visibleUpdate}
        bodyStyle={{ padding: 24 }}
        width={500}
        footer={<div style={{ textAlign: "right" }}></div>}
      >
        <MonthlyPlanUpdate
          monthlyPlanId={monthlyPlanId}
          FirmId={FirmIdUpdate.toString()}
          sendDataForUpdate={getData}
          OtherTransactionProcessType={OtherTransactionProcessTypeUpdate}
          MonthlyPlanTypeId={MonthlyPlanTypeId}
          CurrencyCode={CurrencyCode}
          Amount={Amount}
          isRepeat={isRepeat}
          changeAll={changeAll}
          TransactionDate={TransactionDate}
          Description={DescriptionUpdate}
          teminatDropdown={teminatDropdown}
          currencyDropdown={currencyDropdown}
          ManualTransactionTypeDropdown={ManualTransactionTypeDropdown}
        />
      </Drawer>
    </>
  );
};

export default MonthlyPlanList;
